import styled from 'styled-components';

import { Button as commonButton } from '../../assets/Common/Button.style';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 823px;
  max-width: 90vw;
  min-height: 331px;
  overflow: auto;
  padding: 25px;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.thumb};
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.track};
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 100%;
  padding: 0 0 20px;
  border-bottom: 1px solid ${(props) => props.theme.border};
`;

export const Title = styled.h2`
  display: inline-block;
  color: ${(props) => props.theme.color};
  font-size: 26px;
  font-weight: 600;
  text-align: center;
  cursor: default;
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  align-items: stretch;
`;

export const PreviewBox = styled.div`
  display: block;
  width: 100%;
  text-align: center;
  margin-bottom: 15px;
`;

export const PreviewImageBox = styled.div`
  display: block;
  width: 100%;
  text-align: center;
`;

export const PreviewImage = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
`;

export const Footer = styled.div`
  display: inline-grid;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  grid-template-columns: auto auto;
  grid-gap: 15px;
`;

export const Button = styled.button`
  ${commonButton}
  display: inline-flex;
  width: auto;
  min-width: 175px;
`;
